import {DialogContentText, Paper} from '@material-ui/core';
import {CheckBox} from '@material-ui/icons';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {ISinglePlate} from '../store/types';

interface IProps {
  election: ISinglePlate;
}
const ItemConfirmSingleVoting: React.FC<IProps> = ({election}) => {
  const {t} = useTranslation();
  const {plate, competitors} = election;

  const checkers = competitors.filter(comp => comp.checked);
  const whitesCount: number = plate.configs.choice_max - checkers.length;
  const whites = whitesCount > 0 ? Array.from(Array(whitesCount).keys()) : [];

  return (
    <div className="election">
      <div className="full-width secondary-toolbar">
        <h3 className="mt-0">
          <strong>{plate.name}</strong>
        </h3>
      </div>
      <DialogContentText>
        {checkers.length === 0 && (
          <>
            <span className="warnig-text">
              {t('item-confirmar-votacao-simples.atencao')}
            </span>{' '}
            <br />
          </>
        )}
        {t('item-confirmar-votacao-simples.voce-esta-votando-em')}
      </DialogContentText>
      {checkers.map(part => {
        return (
          <Paper key={part.id} className="white-box" elevation={3}>
            <CheckBox />
            <span>{part.name} </span>
          </Paper>
        );
      })}
      {whites.map(part => {
        return (
          <Paper key={part} className="white-box white-vote" elevation={3}>
            {t('item-confirmar-votacao-simples.branco')}
          </Paper>
        );
      })}
    </div>
  );
};

export default ItemConfirmSingleVoting;



// WEBPACK FOOTER //
// ./src/features/election-single/components/ItemConfirmSingleVoting.tsx